import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { RecordingObjectionStatus } from 'types/recordingObjection';

export const recordingObjectionKeys = {
  status: (medatixxPatientId: string | undefined) =>
    ['recordingObjection', medatixxPatientId] as const,
};

export function useRecordingObjectionStatus(medatixxPatientId: string | undefined) {
  return useQuery<RecordingObjectionStatus>({
    queryKey: recordingObjectionKeys.status(medatixxPatientId),
    queryFn: () =>
      get('recordingObjection', undefined, {
        medatixxPatientId,
      }) as Promise<RecordingObjectionStatus>,
    enabled: !!medatixxPatientId,
    staleTime: 5 * 60 * 1000,
  });
}
